import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Detailed Devalue Report"
  reportDownloadName = "devalueReport"
  apiReportName = "devalueReportWithWallet"
  downloadOnly = {true}
/>
